// extracted by mini-css-extract-plugin
export default {"container":"Privacidade_container__S+bEv","wrapper":"Privacidade_wrapper__k0Sai"};